import React from 'react';

import './interstitial.scss';

const Interstitial = ({children}) => {
  return (
    <div className="interstitalWrap flex flex-col align-center justify-center">
      <div className="interstital" />
      {children}
    </div>
  )
}

export default Interstitial;